import { AnyAction } from 'redux';
import { DesignError } from 'src/store/design/types';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import { addDesignErrorAction } from 'src/store/design/slice';

const addDesignErrorOperation = (error: DesignError) => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
) => {
  dispatch(addDesignErrorAction(error));
};

export default addDesignErrorOperation;
